// extracted by mini-css-extract-plugin
export default {"counter":"counter_counter__W3cFN","clock":"counter_clock__BuQFk"};